<script>
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'SubmitFeedbackForm',

  props: {
    action: {
      type: String,
      required: true,
    },
    referrer: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      subject: '',
      feedback: '',
      errors: {},
      showSuccess: false
    }
  },

  watch: {
    feedback() { this.showSuccess = false },
  },

  methods: {
    submit() {
      this.showSuccess = false
      this.errors = {}
      const data = {
        subject: this.subject,
        feedback: this.feedback,
        referrer: this.referrer,
      }

      const csrftoken = Cookies.get('csrftoken')
      axios.post(this.action, data, {'headers': { 'X-CSRFToken': csrftoken }}).then(
        this.success,
        this.error
      )
    },

    error(error) {
      this.errors = error.response.data.errors
    },

    success(response) {
      this.subject = ''
      this.feedback = ''
      // Resetting the data above will cause showSuccess to be set false next
      // tick, so set it true using $nextTick rather than immediately
      this.$nextTick(function() { this.showSuccess = true })
    },

  },
}
</script>
